import React from 'react'
import { Provider } from 'react-redux'
import store from './store'

import './App.css'
import 'toastr/build/toastr.css'
import Loader from './components/loader/loader'
import ReactGA from 'react-ga'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
function App() {
  ReactGA.initialize('UA-62287527-1')
  ReactGA.pageview('/calculadora-de-calorias')
  return (
    <Provider store={store}>
      <GoogleReCaptchaProvider
        reCaptchaKey="6Lc9X44UAAAAAOJ3ZnJSUQpiV7gfoTD-bsl4dyLl"
        useRecaptchaNet="true"
        language="es"
        scriptProps={{
          async: false, // optional, default to false,
          defer: false, // optional, default to false
          appendTo: 'head', // optional, default to "head", can be "head" or "body",
          nonce: undefined, // optional, default undefined
        }}
      >
        <Loader />
      </GoogleReCaptchaProvider>
    </Provider>
  )
}

export default App
